import { useState, useEffect } from 'react';
import api from '../lib/api';

/** Loads categories (with _id, name, slug, icon) for admin forms. Returns []. */
export default function useCategories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    let alive = true;
    api
      .get('/categories?all=true')
      .then((r) => alive && setCategories(r.data.map((c) => ({ id: c._id, name: c.name, slug: c.slug, icon: c.icon }))))
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return categories;
}
